import { render } from "./TreeItem.vue?vue&type=template&id=73d2ce28&scoped=true&ts=true"
import script from "./TreeItem.vue?vue&type=script&lang=ts"
export * from "./TreeItem.vue?vue&type=script&lang=ts"

import "./TreeItem.vue?vue&type=style&index=0&id=73d2ce28&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73d2ce28"]])

export default __exports__